// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ru: {
    translation: {
      general: {
        next: "Следующая",
        previous: "Предыдущая",
        download: "Скачать",
        cancel: "Отмена",
        confirm: "Подвердить",
        reject: "Отклонить",
        yes: "Да",
        no: "Нет",
        userData: "Данные пользователя",
        close: "Закрыть"

      },
      header: {
        title: "Национальный удостоверяющий центр",
        subtitle: "Республики Казахстан",
        link1: "Повторное получение",
        link2: "Обновить данные",
        link3: "Добавление модуля для NCALayer",
        log: "Первичное получение SDK"
      },
      footer: {
        companyName: "© 2025 АО «Национальные информационные технологии» ",
        address:
          "Адрес: Республика Казахстан, 010000, г. Астана, левобережье, пр. Мәңгілік Ел 55/15, Бизнес - центр «EXPO»",
        number:
          "Телефон: 8-800-080-7777; 1414 (бесплатная телефонная линия на территории РК)",
        support: "Техническая поддержка:",
      },
      userAgreement: {
        checkBox:
          "Я прочитал(-а) и согласен(-на) с условиями пользовательского соглашения.",
        buttonMainPage: "Вернуться на главную страницу",
        button: "Подтвердить",
      },
      authentication: {
        title: "Аутентификация",
        authWarningTitle: "Уведомление об ответственности",
        authWarning:
          "Я, пользователь информационной системы «Национальный удостоверяющий центр Республики Казахстан» (далее – Система), продолжая работу на интернет-ресурсе Системы подтверждаю свое согласие, что несу ответственность за все осуществленные действия в соответствии с Законом Республики Казахстан от 7 января 2003 года N 370 «Об электронном документе и электронной цифровой подписи».",
        checkBox: "Подтверждаю",
        button: "Выбрать ключ ЭЦП",
      },
      userSelector: {
        userSelectorTitle: "РЕГИСТРАЦИЯ ЗАЯВКИ ДЛЯ ПОЛУЧЕНИЯ SDK",
        ulButton: "Юридическое лицо",
        flButton: "Физическое лицо",
      },
      SDKUserForm: {
        titleRegistration: "Регистрация заявки для получения SDK",
        titleUpdate: "Обновление данных",
        formTitle: "Данные для регистрации заявки",
        captchaText: "Введите код с картинки",
        checkIin: "Проверить",
        check: "Проверить",
        organizationName: "Наименование организации",
        informationSystemNameOwner: "Владелец информационной системы",
        informationSystem: "Информационная система",
        bin: "БИН",
        iin: "ИИН",
        fio: "ФИО",
        role: "Роль",
        phoneNumber: "Номер телефона",
        errorPhoneNumber:
          "Некорректный номер. Пожалуйста, введите правильный номер телефона.",
        email: "Электронная почта",
        errorEmail: "Некорректный email. Пожалуйста, введите правильный адрес.",
        userCount: "Планируемое количество пользователей ИС",
        noteUpdate:
          "Примечание: при необходимости актуализируйте информацию о информационной системе",
          noteRegistration:
          " Примечание: необходимо подписать посредством ЭЦП для юридических лиц «Первого руководителя» или «Сотрудника с правом подписи» Вашей организации",
        signButton: "Подписать",
        successTitle: "ВАША ЗАЯВКА УСПЕШНО РЕГИСТРИРОВАНА",
        successText1:
          "Ваша заявка на получение SDK успешно зарегистрирована. Переходите по",
        successText2: "ссылке",
        successText3:
          " и введите вашу электронную почту для получения одноразовой ссылки.",
        mandatoryPlaceholder: "example",
        selectIS: "Выберите информационную систему",
        moduleHint:"Примечание: необходимо подписать посредством ЭЦП для",
        moduleHintNext:"юридических лиц «Первого руководителя» или «Сотрудника с правом подписи» Вашей организации, а для физических лиц — по шаблону «Физическое лицо»",
        informSystemPlace: "example",
        moduleName: "Модуль example",
        desciptionPlaceholder: "Текст",
        functionList: "Текст",
        moduleSum: "1234567890321654avbgh451856",
      },
      SDKUserUpdate:{
        userUpdateRegistration: " Примечание: Для выполнения данной операции потребуется ваша ЭЦП.",
        userUpdate:"Убедитесь, что она совпадает с подписью, использованной при авторизации."
      },
      
      NCALayerModuleForm: {
        sortStatus:"Сортировать по статусу",
        sortDate:"Сортировать по дате",
        profile: "Профиль",
        title: "Регистрация заявки для добавления модуля NCALayer",
        moduleApplications: "Заявки",
        moduleName: "Наименования модуля",
        moduleEmail: "Электронная почта",
        moduleVersion: "Версия модуля",
        errorVersionModule: "Некорректный версия. Пожалуйста, введите правильную версию.",
        moduleDescription: "Краткое описание модуля",
        moduleFunctions: "Список реализованных внешних функций",
        moduleChecksum: "Контрольная сумма модуля (MD5)",
        moduleURL: "Место размещения модуля (URL)",
        moduleIsolation: "Изолирована от сети Интернет (ДА/НЕТ)",
        moduleFileAttachment: "Прикрепление файла (модуль)",
        moduleDateCreate: "Дата создания заявки",
        moduleStatus: "Статус",
        adminModuleTitle: "Заявки по модулям NCALayer",
        adminProfileTitle: "Профиль",
        adminChangeButton: "Изменить",
        adminAddButton: "Добавить",
        adminSaveButton: "Сохранить",
        adminEmailPlaceholder: "Введите электронную почту",
        selectFile: "Выбрать файл",
        adminReports: "Отчеты",
        adminSDKReport: "Отчеты по SDK",
        adminNCALayerModuleReport: "Отчеты по модулям NCALayer",
        adminEmail: "Почта администратора",
        developerEmail: "Почта разработчика",
        nmUserSuccess: "Ваша заявка успешно зарегистрировано, ожидайте ответа от менеджера НУЦ РК",
        nmRegistration:
          " Примечание: необходимо подписать посредством ЭЦП «Первого руководителя» или «Сотрудника с правом подписи» Вашей организации",
      },

      getSDKForm:{
        emailNotFound: "Email не найден. Пожалуйста, проверьте правильность ввода.",
        errorResponse: "Произошла ошибка при отправке запроса. Попробуйте позже.",
        getSDK: "Повторное получение SDK. Введите e-mail указанный при регистрации",
        getURL: "Получить ссылку",
        sendEmail: "Отправка...",
        success: "Ссылка на загрузку SDK отправлена на ваш email.",


      },

      NmAdmin:{
        confirming: "Подвердить",
        closing: "Закрыть",
        rejecting: "Отклонить"
      },

      error: {
        mainError: "Ошибка",
        defaultError: "Что-то пошло не так. Попробуйте позже.",
        informationSystemNotFoundError:
          "Информационная система не найдена в базе",
        invalidSignatureErrorFl:
          "Недопустимый ЭЦП - используйте ключ физического лица",
        invalidSignatureError: "Недопустимый ЭЦП",
        serverError: "Данные от сервера отсутствуют или некорректны",
        correctInputError: "Корректно заполните все поля",
        captchaError: "Ошибка при получении изображения CAPTCHA",
        captchaInputError: "Неправильно указан код с картинки",
        userNotFoundError: "Пользователь с данным ИИН не найден",
        userBinNotFoundError: "Организация с данным БИН не найден",
        // underAgeError: 'Данное физическое лицо не достигло 16 лет',
        underAgeError:
          "Выдача SDK по указанному  ИИН – не возможна, на основании Статьи 14. Главы 4 Закона Республики Казахстан «Об электронном документе и электронной цифровой подписи», регистрационное свидетельство выдается лицу, достигшему шестнадцатилетнего возраста, в порядке установленном уполномоченным органом в сфере информатизации.",
        decasedError:
          "Согласно информации из Государственной базы данных физических лиц (далее - ГБД ФЛ), указанный ИИН имеет статус «Умерший». Для получения дополнительной информации Вам необходимо обратиться в ГБД ФЛ.",
        foreignKeyError: "Подпишите заявку ключами по шаблону «Юридическое лицо-Первый руководитель» или «Юридическое лицо-Сотрудник с правом подписи»",
        ncalayer: "Убедитесь, что NCALayer запущен",
        adminEmailError: "Неверный формат электронной почты",
        notAdminOrManager: "Пользователь не является менеджером или администраторам",
        revokedKeyError: "Подпись недействительна: сертификат отозван или ошибка на стороне сервера",
        notFoundError: "Пользователь с указанными данными не найден в базе НУЦ РК. Необходимо перейти по меню «первичное получение SDK» для регистрации",
        foreignKeyErrorForm: "Подпишите заявку ключами по шаблону «Юридическое лицо-Первый руководитель» или «Юридическое лицо-Сотрудник с правом подписи», а для физических лиц — по шаблону «Физическое лицо»."
      },
      sort: {
        sortByDate: "Сортировать по дате",
        sortByStatus: "Сортировать по статусу"
      }

      // Добавьте другие строки перевода, если необходимо
    },
  },
  kz: {
    translation: {
      general: {
        next: "Келесі",
        previous: "Алдыңғы",
        download: "Жүктеу",
        cancel: "Болдырмау",
        confirm: "Қабылдау",
        reject: "Қабылдамау",
        yes: "Иә",
        no: "Жоқ",
        userData: "Пайдаланушының деректері",
        close: "Жабу"
      },
      header: {
        title: "Қазақстан Республикасының",
        subtitle: "Ұлттық куәландырушы орталығы",
        link1: "Қайта алу",
        link2: "Деректерді жаңарту",
        link3: "NCALayer модулін қосу",
        log: "SDK-ны бастапқы алу"
      },
      footer: {
        companyName: "© 2025  «Ұлттық ақпараттық технологиялар» АҚ",
        address:
          'Мекен-жайы: Қазақстан Республикасы, 010000, Астана қ, Сол жағалау, Мәңгілік Ел д-лы, 55/15, "EXPO" бизнес орталығы',
        number:
          "Телефон: 8-800-080-7777; 1414 (ҚР аумағында тегін қоңырау шалу желісі)",
        support: "Техникалық көмек:",
      },
      userAgreement: {
        checkBox: "Пайдаланушылық келісімді оқыдым және шарттарымен келісемін.",
        buttonMainPage: "Бастапқы бетке қайту",
        button: "Енгізу",
      },
      authentication: {
        title: "Түпнұсқаландыру",
        authWarningTitle: "Жауапкершілік туралы хабарлама",
        authWarning:
          'Мен, Қазақстан Республикасының "Ұлттық куәландырушы орталығы" ақпараттық жүйесінің (бұдан әрі – Жүйе) пайдаланушысы, Жүйенің интернет-ресурсында жұмысты жалғастыра отырып, "Электрондық құжат және электрондық цифрлық қолтаңба туралы" Қазақстан Республикасының 2003 жылғы 7 қаңтардағы N 370 Заңына сәйкес жүзеге асырылған барлық іс-әрекеттер үшін жауапкершілік артатынымды растаймын.',
        checkBox: "Растаймын",
        button: "ЭЦҚ кілтін таңдау",
      },

      userSelector: {
        userSelectorTitle: "SDK АЛУ ҮШІН ӨТІНІМДІ ТІРКЕУ",
        ulButton: "Заңды тұлға",
        flButton: "Жеке тұлға",
      },
      SDKUserForm: {
        titleRegistration: "SDK алу үшін өтінімді тіркеу",
        titleUpdate: "Деректерді жаңарту",
        formTitle: "Өтінімді тіркеуге арналған деректер",
        captchaText: "Суреттегі кодты енгізіңіз",
        checkIin: "Тексеру",
        check: "Тексеру",
        organizationName: "Ұйымның атауы",
        informationSystemNameOwner: "Aқпараттық жүйенің иесі",
        informationSystem: "Ақпараттық жүйе",
        bin: "БСН",
        iin: "ЖСН",
        fio: "Аты-жөні",
        role: "Рөл",
        phoneNumber: "Телефон нөмірі:",
        errorPhoneNumber: "Қате нөмір. Дұрыс телефон нөмірін енгізіңіз.",
        email: "Электрондық пошта:",
        errorEmail:
          "Электрондық пошта қате енгізілген. Дұрыс поштаны енгізіңіз.",
        userCount: "АЖ пайдаланушыларының жоспарланған саны:",
        ескерту:
          "Ескерту: қажет болса, ақпараттық жүйе туралы ақпаратты жаңартыңыз",
          noteRegistration: 'Ескерту: Сіздің ұйымыңыздың заңды тұлғалары үшін "Бірінші басшы" немесе "Қол қою құқығы бар қызметкер" ЭЦҚ-сы арқылы қол қою қажет.',

        signButton: "Қол қою",
        successTitle: "Сіздің өтініміңіз сәтті тіркелді",
        successText1: "Сіздің SDK өтініміңіз сәтті тіркелді. Осы ",
        successText2: "сілтемеге",
        successText3:
          " өтіп, бір реттік сілтеме алу үшін электрондық поштаңызды енгізіңіз.",
        mandatoryPlaceholder: "example",
        selectIS: "Ақпараттық жүйені таңдаңыз",
        informSystemPlace: "example",
        moduleName: "example модулі",
        desciptionPlaceholder: "Мәтін",
        functionList: "Мәтін",
        moduleSum: "1234567890321654avbgh451856",
        moduleHint:"Ескерту: Сіздің ұйымыңыздың заңды тұлғалары үшін",
        moduleHintNext:'"Бірінші басшы" немесе "Қол қою құқығы бар қызметкер" ЭЦҚ-сы арқылы қол қою қажет, ал жеке тұлғалар үшін – «Жеке тұлға» үлгісі бойынша',
      },

      SDKUserUpdate: {
        userUpdateRegistration: "Ескерту: Бұл операцияны орындау үшін сіздің ЭЦҚ қажет. ",
        userUpdate:"Авторизация кезінде пайдаланылған қолтаңбамен сәйкес келетініне көз жеткізіңіз."
    },
    
     
      NCALayerModuleForm: {
        sortStatus:"Статусы бойынша сұрыптау",
        sortDate:"Күні бойынша сұрыптау",
        profile: "Жеке профиль",
        title: "NCALayer модулін қосу үшін өтінімді тіркеу",
        moduleApplications: "Өтінімдер",
        moduleName: "Модуль атауы",
        moduleVersion: "Модуль нұсқасы",
        errorVersionModule: "Дұрыс емес нұсқа. Дұрыс нұсқаны енгізіңіз.",
        moduleDescription: "Модульдің қысқаша сипаттамасы",
        moduleFunctions: "Орындалған сыртқы функциялар тізімі",
        moduleChecksum: "Модуль бақылау сомасы (MD5)",
        moduleURL: "Модуль орны (URL)",
        moduleIsolation: "Интернеттен оқшауланған (ИӘ/ЖОҚ)",
        moduleFileAttachment: "Файл тіркемесі (модуль)",
        moduleDateCreate: "Өтінімнің жасалған күні",
        moduleStatus: "Статус",
        adminModuleTitle: "NCALayer модулдері бойынша өтінімедер тізімі",
        adminProfileTitle: "Жеке профиль",
        adminChangeButton: "Өзгерту",
        adminAddButton: "Қосу",
        adminSaveButton: "Сақтау",
        adminEmailPlaceholder: "Электрондық поштаңызды енгізіңіз",
        selectFile: "Файлды таңдаңыз",  
        adminReports: "Есептер",
        adminSDKReport: "SDK бойынша есеп",
        adminNCALayerModuleReport: "NCALayer моудльдері бойынша есеп",
        adminEmail: "Администратордың поштасы",
        developerEmail: "Әзірлеушінің поштасы",
        nmUserSuccess: "Сіздің өтініміңіз сәтті тіркелді, ҚР ҰКО менеджерінен жауап күтіңіз",
        nmRegistration:
          "Ескерту: Сіздің ұйымыңыздың заңды тұлғалары үшін 'Бірінші басшы' немесе 'Қол қою құқығы бар қызметкер' ЭЦҚ-сы арқылы қол қою қажет."
      
      },

      getSDKForm:{
        emailNotFound: "Электрондық пошта табылмады. Жазбаңыздың дұрыстығын тексеріңіз.",
        errorResponse: "Сұраныс жіберу кезінде қате пайда болды. Кейінірек көріңіз.",
        getSDK: "SDK-ны қайта алу. Тіркелу кезінде көрсетілген e-mail енгізіңіз",
        getURL: "Сілтемені алу",
        sendEmail: "Жіберу...",
        success: "SDK жүктеп алу сілтемесі электрондық поштаңызға жіберілді."
      },

      NmAdmin:{
        confirming: "Қабылдау",
        closing: "Жабу",
        rejecting: "Қабылдамау"
      },

      error: {
        mainError: "Қате",
        defaultError: "Белгісіз қате.Кейінірек көріңіз",
        informationSystemNotFoundError: "Ақпараттық жүйе дерекқордан табылмады",
        invalidSignatureErrorFl: "Қате ЭЦҚ - жеке тұлғаның кілтін пайдаланыңыз",
        invalidSignatureError: "Қате ЭЦҚ",
        serverError: "Серверден деректер жоқ немесе дұрыс емес",
        correctInputError: "Барлық жолдарды дұрыс толтырыңыз",
        captchaError: "CAPTCHA кескінін алу кезінде қате анықталды",
        captchaInputError: "Суреттегі код қате терілді",
        userNotFoundError: "Осы ЖСН бойынша пайдаланушы табылмады",
        userBinNotFoundError: "Осы БСН бойынша ұйым табылмады",
        underAgeError:
          "Көрсетілген ЖСН бойынша SDK беру мүмкін емес, «Электрондық құжат және электрондық цифрлық қолтаңба туралы» Қазақстан Республикасының заңы 4-бөлімінің 14-бабы негізінде тіркеу куәлігі ақпараттандыру саласындағы уәкілетті орган белгілеген тәртіппен он алты жасқа толған тұлғаға беріледі.",
        decasedError:
          "Жеке тұлғалардың мемлекеттік дерекқорынан (бұдан әрі-ЖТ МДҚ) алынған ақпаратқа сәйкес көрсетілген ЖСН мәртебесі «Қайтыс болған».  Қосымша ақпарат алу үшін ЖТ МДҚ-ға  хабарласуыңыз қажет.",
        foreignKeyError: "Өтінішке «Заңды тұлға – бірінші басшы» немесе «Заңды тұлға – қол қою құқығы бар қызметкер» үлгісіне сәйкес кілттермен қол қою керек",
        ncalayer: "NCALayer жұмыс істеп тұрғанына көз жеткізіңіз",
        adminEmailError: "Электронды поштаны дұрыс теріңіз",
        notAdminOrManager: "Пайдаланушы менеджер немесе админ емес",
        revokedKeyError: "Қолтаңба жарамсыз: сертификат кері қайтарылған немесе серверлік қате",
        notFoundError: "Көрсетілген деректері бар пайдаланушы ҚР ҰКО дерекқорында табылмады. Тіркелу үшін «SDK-ны бастапқы алу» мәзіріне өту қажет",
        foreignKeyErrorForm: "Өтінімді «Заңды тұлға – Бірінші басшы» немесе «Заңды тұлға – Қол қою құқығы бар қызметкер» кілттерімен қол қойыңыз, ал жеке тұлғалар үшін – «Жеке тұлға» үлгісі бойынша."

      },
      sort: {
        sortByDate: "Күні бойынша сұрыптау",
        sortByStatus: "Мәртебесі бойынша сұрыптау"
      }
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ru", // default language
  interpolation: {
    escapeValue: false, // not needed for React as it escapes by default
  },
});

export default i18n;
